import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import DynamicForm from '../common/DynamicForm';
import LoaderComponent from "../../../libraries/loader/loader";
import { Fetchexecutequery, Fetchheaderdata,Fetchupdatequery } from '../../../services/process/BRS1/brsService7';
import { Icon } from 'semantic-ui-react';
import Select from "react-select";
import { CreateData} from '../../../services/process/process_data/process_data';
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";

function DepartmentCreation() {
  const [formData, setFormData] = useState({groups_id: null,tenants_id:null,entity_id:null,kpis_json:[],jobs_json:[],sources_json:[],pages_json:[]});
  const [userCredentials] = useState(JSON.parse(sessionStorage.getItem("userCredentials")));
  const [filterconditions,setFilterconditions] =  useState([{"is_active" : 1,"entity_id" : userCredentials.selectedentity,"tenant_id": userCredentials.tenants_id,"group_id": userCredentials.groups_id}]);
  const [fields, setFields] = useState(null);
  const [rowData, setRowData] = useState([]);
  const [columnDefs, setColumnDefs] = useState([]);
  const [error, setError] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState('');
  const [activeTab, setActiveTab] = useState(0);
  const gridRef = useRef(null);

  const getFormattedDate = () => {
    const currentDate = new Date();
    return currentDate.toISOString().slice(0, 19).replace("T", " ");
  };

  const handleDeleteclick = (row) => {
  const isConfirmed = window.confirm("Are you sure you want to delete this item?");
  if (!isConfirmed) {
    return; // Stop execution if user clicks "No"
  }
    console.log('formData',row,row.primary_id)
    const updatedFormData = row;

    // Remove primary_id from the copied formData
    // delete updatedFormData.primary_id;
    const payload = {
      schema_name: 'process_data',
      table: 'process',
      set_column : {is_active : 0},
      'where' : [{"primary_id":row.primary_id}]
    };

    const FileUploadCredentials = Fetchupdatequery();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(response => {
        console.log("Update response:", response);
        setEditMode(false); // Reset edit mode after updating
        window.location.reload();
      })
      .catch((error) => {
        console.error("Error updating data:", error);
        setError("Error updating data");
      });
  };

const handleTabChange1 = (index) => {
  fetchFieldInfo1(index);
  setActiveTab(index);
};

  const formatColumnName = (name) =>
    name.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());

  useEffect(() => {
    fetchFieldInfo1(0);
  }, []);

  const fetchFieldInfo1 = async (index) => {
    const payload = { headerconfig_id: index + 76,"filterconditions":filterconditions  };

    try {
      const FileUploadCredentials = Fetchheaderdata();
      const response = await axios.post(
        FileUploadCredentials[1], // URL
        payload,                  // Payload
        FileUploadCredentials[0]   // Headers or Credentials
      );

      const data = response.data;
      if (data.fields && data.fields.length > 0) {
        const columns = data.fields.map((field) => ({
          headerName: formatColumnName(field.columnName),
          field: field.columnName,
          filter: true,
        sortable: true,
          resizable: true,

        }));
        columns.push({
          headerName: "Edit",
          field: "edit",
          cellRendererFramework: (params) => (
            <Icon
              name="edit"
              style={{ cursor: 'pointer' }}
              onClick={() => handleEditClick(params.data)}
            />
          ),
          width: 80, // Set width for the edit column
        });

        columns.push({
          headerName: "Delete",
          field: "delete",
          cellRendererFramework: (params) => (
            <Icon
              name="trash"
              style={{ cursor: 'pointer', color: "red" }}
              onClick={() => handleDeleteclick(params.data)}
            />
          ),
          width: 150, // Set width for the edit column
        });

        setColumnDefs(columns);
        setFields(data.fields);
        console.log("fields fetched",data.fields)

setLoading(false);
      }
    } catch (error) {
      console.error("Error fetching field info:", error);
      setError("Error fetching fields data");
setLoading(false);
    }
  };


const handleEditClick = (row) => {
    console.log("Editing row:", row);

    const updatedRowData = {
        ...row,
        kpis_json: row["kpis"] ? JSON.parse(row["kpis"]) : [],
        pages_json: row["pages"] ? JSON.parse(row["pages"]) : [],
        sources_json: row["sources"] ? JSON.parse(row["sources"]) : [],
        jobs_json: row["jobs"] ? JSON.parse(row["jobs"]) : []
    };
    setFormData(updatedRowData); // Populate formData with row data for editing
    setEditMode(true); // Set edit mode to true
};

const fetchOptionsInfo = async (query1,label1,value1,setinfo) => {
  const payload = { query: query1 };

  try {
    const FileUploadCredentials = Fetchexecutequery();
    const response = await axios.post(
      FileUploadCredentials[1],
      payload,
      FileUploadCredentials[0]
    );

    const data = response.data;
    const formattedData = data.map(item => ({
      label: item[label1],
      value: item[value1]
    }));

    setinfo(formattedData);
    console.log("Formatted data fetched:", formattedData);
    
  } catch (error) {
    console.error("Error fetching page data:", error);
    setError("Error fetching page data");
  }
};


  const handleCreate = () => {

      const formattedDate = getFormattedDate();
      const updatedFormData = {
        ...formData,
      };


    const payload = {
      database: 'process_data',
      table: 'process',
      formData: updatedFormData
    };

    const FileUploadCredentials = CreateData();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(response => {
        console.log("Create response:", response);
        window.location.reload();
      })
      .catch((error) => {
        console.error("Error creating data:", error);
        setError("Error creating data");
      });
  };

  const handleUpdate = () => {
    
    console.log('formData',formData,formData.id)
    const updatedFormData = { ...formData };

    // Remove primary_id from the copied formData
    delete updatedFormData.primary_id;
    const payload = {
      schema_name: 'process_data',
      table: 'process',
      set_column : updatedFormData,
      'where' : [{"primary_id":formData.primary_id}]
    };

    const FileUploadCredentials = Fetchupdatequery();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(response => {
        console.log("Update response:", response);
        setEditMode(false); // Reset edit mode after updating
        window.location.reload();
      })
      .catch((error) => {
        console.error("Error updating data:", error);
        setError("Error updating data");
      });
  };

  const handleInputChange = (name, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

useEffect(() => {
  setFormData({});
}, [fields]);

const handleInputChange1 = (selectedOptions, name, isMulti = false) => {
  setFormData((prevData) => ({
    ...prevData,
    [name]: isMulti
      ? selectedOptions.map(option => option.value) // Store as an array for multi-select
      : selectedOptions.value, // Store single value for non-multi-select
  }));
};

  const onFilterTextChange = (event) => {
    const { value } = event.target;
    setSearchText(value);
  };


  const handleSubmit = (e) => {
    e.preventDefault();
    if (editMode) {
      handleUpdate();
    } else {
      handleCreate();
    }
  };

 if (loading) return <LoaderComponent loaderOpen={true}/>;

  return (
    <div>
      <h2 className="pt-1 pb-1 text-center" style={{ color: "#4969ab", fontSize: '18px' }}>
        Organization Registration
      </h2>

      <Tabs selectedIndex={activeTab} onSelect={(index) => handleTabChange1(index)}>
        <TabList>
          <Tab>Tenants</Tab>
          <Tab>Groups</Tab>
          <Tab>Entity</Tab>
          <Tab>Division</Tab>
          <Tab>Department</Tab>
        </TabList>

      {error && <div style={{ color: "red" }}>{error}</div>}
<TabPanel>
    {activeTab === 0 && fields &&
      <DynamicForm fields={fields} formData={formData} onInputChange={handleInputChange} />
    }
  </TabPanel>

  <TabPanel>
    {activeTab === 1 && fields &&
      <DynamicForm fields={fields} formData={formData} onInputChange={handleInputChange} />
    }
  </TabPanel>

  <TabPanel>
    {activeTab === 2 && fields &&
      <DynamicForm fields={fields} formData={formData} onInputChange={handleInputChange} />
    }
  </TabPanel>

  <TabPanel>
    {activeTab === 3 && fields &&
      <DynamicForm fields={fields} formData={formData} onInputChange={handleInputChange} />
    }
  </TabPanel>

  <TabPanel>
    {activeTab === 4 && fields &&
      <DynamicForm fields={fields} formData={formData} onInputChange={handleInputChange} />
    }
  </TabPanel>      </Tabs>
      <div
        className="ag-theme-alpine"
        style={{
          overflowX: 'auto',
          overflowY: 'auto',
          borderRadius: '10px',
          width: `${6 * 250}px`,
          height: '350px'
        }}
      >
<AgGridReact
  ref={gridRef}
  rowData={rowData}
  columnDefs={columnDefs}
  pagination={true}
  paginationPageSize={8}
  filter={true}
  rowSelection="multiple" // or "single"
  suppressRowClickSelection={true}
  enableRangeSelection={true}
  suppressCopyRowsToClipboard={false}
/>

      </div>

    </div>
  );
}

export default DepartmentCreation;
